import React, { Component } from 'react';
import './App.css';
import { MuiThemeProvider } from '@material-ui/core/styles';
import theme from './providers/theme-provider';
import AppRouter from './providers/route-provider';
import { StoreProvider } from "./providers/global-store-provider";
import Snackbar from './components/common/libs/SnackBar';
//import Notification from './components/common/libs/Notification';
/* import { BackgroundNotificationHandler } from './providers/notifications-provider';
 */import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

class App extends Component {
  componentDidMount() {
    let preloader = document.getElementById('preloader');
    if (preloader) {
      let fadeDiv = document.getElementById('preloader-image-fade');
      fadeDiv.className = '';
      setTimeout(function () { preloader.style.display = 'none'; }, 50);
    }
  }
  render() {
    return (
      <StoreProvider >
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <MuiThemeProvider theme={theme}>
            <AppRouter></AppRouter>
            <Snackbar />{/* Used for success/error messsages */}
            {/* <Notification /> */}
            {/*  <BackgroundNotificationHandler /> */}
          </MuiThemeProvider>
        </MuiPickersUtilsProvider>
      </StoreProvider>

    );
  }
}

export default App;
